(function (root) {
  'use strict';
  const normalize = value => String(value || '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ').replace(/\bsaint\b/g,'st');
  const quote = value => '"' + String(value).replace(/[\\"]/g, '\\$&') + '"';
  const colorNames = ['light blue','royal blue','navy blue','forest green','hunter green','ash grey','ash gray','heather grey','heather gray','navy','royal','maroon','burgundy','black','white','grey','gray','red','green','gold','pink','purple','orange','yellow','khaki'];
  // School names, finder collection handles and search shortcuts have one
  // source: snippets/liebmans-school-directory.liquid. snippets/predictive-search.liquid
  // renders it next to each search form as
  // <script type="application/json" data-liebmans-school-directory>.
  // Node callers (tests) set root.LiebmansSchoolDirectory first.
  let directory = null;
  function schoolDirectory() {
    if (directory) return directory;
    let data = root.LiebmansSchoolDirectory;
    if (!data && typeof document !== 'undefined') {
      const node = document.querySelector('script[data-liebmans-school-directory]');
      if (node) {
        try { data = JSON.parse(node.textContent); } catch (error) { data = null; }
      }
    }
    if (!Array.isArray(data)) return [];
    directory = data.map(school => ({
      name: String(school.name || ''),
      url: String(school.url || ''),
      aliases: Array.isArray(school.aliases) ? school.aliases.map(alias => normalize(alias)) : []
    }));
    return directory;
  }
  function retiredSchool(raw) {
    let data = root.LiebmansRetiredSchools;
    if (!data && typeof document !== 'undefined') {
      const node = document.querySelector('script[data-liebmans-retired-schools]');
      if (node) {
        try { data = JSON.parse(node.textContent); } catch (error) { data = []; }
      }
    }
    const normalized = ' ' + normalize(raw) + ' ';
    return Array.isArray(data) ? data.find(school => school.aliases.some(alias => normalized.includes(' ' + normalize(alias) + ' '))) : null;
  }
  function build(raw) {
    raw = String(raw || '').trim();
    if (retiredSchool(raw)) return {query:raw,strict:true,school:'',retired:true};
    if (!raw || /[:"()\\]|\b(?:AND|OR|NOT)\b/.test(raw) || /^\S*[-/]\S*\d\S*$/.test(raw)) return {query:raw,strict:false};
    let rest = normalize(raw);
    const matches = schoolDirectory().map(school => {
      const base = normalize(school.name).replace(/ school$/, '');
      const values = [normalize(school.name),base,...school.aliases].sort((a,b)=>b.length-a.length);
      return {school,base,matched:values.find(v => (' '+rest+' ').includes(' '+v+' '))};
    }).filter(m=>m.matched).sort((a,b)=>b.matched.length-a.matched.length);
    const school = matches[0];
    const parts = [];
    if (school) {
      parts.push('title:'+quote(school.school.name.replace(/ School$/, '')));
      rest = (' '+rest+' ').replace(' '+school.matched+' ',' ').trim();
    }
    const colors=[];
    for (const color of colorNames) {
      if ((' '+rest+' ').includes(' '+color+' ')) {
        colors.push(color);
        rest=(' '+rest+' ').replaceAll(' '+color+' ',' ').trim();
      }
    }
    if (!school && !colors.length) return {query:raw,strict:false};
    for (const color of colors) {
      const values = color.includes('grey') ? [color,color.replace('grey','gray')] : color.includes('gray') ? [color,color.replace('gray','grey')] : [color];
      parts.push('('+values.flatMap(v=>['title:'+quote(v),'variants.title:'+quote(v)]).join(' OR ')+')');
    }
    const singular = {shorts:'short',polos:'polo',hoodies:'hoodie',shirts:'shirt',sweatshirts:'sweatshirt',skirts:'skirt',cardigans:'cardigan',vests:'vest'};
    rest.split(' ').filter(word=>word && !['for','the','at','with','a','an'].includes(word)).forEach(word=>parts.push('title:'+quote(singular[word] || word)));
    return {query:parts.join(' AND '),strict:true,school:school?.school.name || '',colors};
  }
  function display(query) {
    if (!query.includes('title:"')) return query;
    const values = [...query.matchAll(/(?:title|variants\.title):"([^"\\]*)"/g)].map(m=>m[1]);
    return [...new Set(values)].join(' ');
  }
  root.LiebmansSearch = {build,display,get schools() { return schoolDirectory().map(school => ({name: school.name, url: school.url})); }};
  if (typeof module !== 'undefined' && module.exports) module.exports = root.LiebmansSearch;
})(typeof window !== 'undefined' ? window : globalThis);

